import React from "react";
import { NavLink } from "react-router-dom";
import { Header } from '../../Components/Layout/Header.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import RiveComponent from "../../Components/Shared/RiveComponent";

export class FirstDepositBonus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            button1: false,
            button2: false,
            button3: false,
        }

        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Bonus dobrodoslice', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
    }

    handleClick(buttonNumber) {
        window.scrollTo(0, 0);
        const newState = {};
        newState[`button${buttonNumber}`] = true;
        this.setState(newState);
    }

    handleClickBack(buttonNumber) {
        const newState = {};
        newState[`button${buttonNumber}`] = false;
        this.setState(newState);
    }

    renderStep1() {
        return (
            <div className="top-part" id="top-part-1">
                <div className="top-part-header">
                    <span className="step-number">1</span>
                   {/* <img src="content/images/bonusi/firstdeposit/step_1.png" />*/}
                    <div className="step-image-1"></div>
                </div>
                <div className="top-part-footer">
                    <h1>Registriraj se</h1>
                    <h2>Osvoji 100 BESPLATNIH VRTNJI</h2>
                    <p>Pridruži se dokazano najboljem Casinu jer te čeka poklon dobrodošlice - 100 besplatnih vrtnji bez potrebe za uplatom!</p>
                    <button onClick={() => this.handleClick(1)}>SAZNAJ VIŠE</button>
                </div>
            </div>
        );
    }

    renderStep1How() {
        return (
            <>
                <div className="bottom-part">
                    <div className="back-button-container">
                        <button className="back-button" onClick={() => this.handleClickBack(1)}>
                            <span className="arrow-back-transparent"></span>
                            Povratak
                        </button>
                    </div>
                    <div className="how">
                        <span>KAKO DO 100 BESPLATNIH VRTNJI?</span>
                    </div>

                    <p>Za osvajanje <b>70 besplatnih vrtnji</b> u igri Hot to Burn potvrdi identitet putem aplikacije Sporti, u poslovnici SuperSporta ili se javi na email <a className="link red" href="mailto:ssport@supersport.hr"><b>ssport@supersport.hr</b></a> pa ćemo dogovoriti termin identifikacije.</p>
                    <p>A ako uz to označiš i “Želim primati novosti o bonusima, nagradama, posebnim ponudama ili novim proizvodima putem:<a className="link red" href="https://m.supersport.hr/racun#/postavke_privatnosti" target="_blank"><b> email poruka, SMS-a i drugih komunikacijskih kanala</b> </a> ”, osvojit ćeš još <b>30 besplatnih vrtnji</b> u igri Big Bass Splash. </p>

                    <p className="thin">Besplatne vrtnje su vrijednosti 0,1 € po vrtnji.</p>
                    <p className="thin">
                        Sav dobitak osvojen besplatnim vrtnjama moraš odigrati barem 5 puta u Casino igrama da bi ga mogao isplatiti na svoj račun.
                    </p>
                </div>
                <div className="games">
                    <h3>IGRE S BESPLATNIM VRTNJAMA</h3>
                    <div className="besplatna-vrtnja-igra">
                        <NavLink to={{ pathname: '/promotions/first-deposit/game/big-bass-splash' }}>
                            <img src={"https://cdn.supersport.hr/casino/gameimages/pragmaticplay/big-bass-splash-xicon-m.webp"} />
                        </NavLink>
                        <div className="game-name">
                            Big Bass Splash
                            <p>
                                Zabaci svoju sretnu udicu i istraži slatkovodne dobitke uz 30 besplatnih vrtnji u igri <NavLink className="link red" to={{ pathname: '/promotions/first-deposit/game/big-bass-splash' }}><b>Big Bass Splash</b></NavLink>.</p>
                        </div>
                    </div>
                    <div className="besplatna-vrtnja-igra">
                        <NavLink to={{ pathname: '/promotions/first-deposit/game/hot-to-burn' }}>
                            <img className="mt" src={"https://cdn.supersport.hr/casino/gameimages/pragmaticplay/hot-to-burn-xicon-m.webp"} />
                        </NavLink>
                        <div className="game-name">
                            Hot to Burn
                            <p>Uz voćkice nikad nije hladno. Otkrij užarene dobitke uz 70 besplatnih vrtnji u igri <NavLink className="link red" to={{ pathname: '/promotions/first-deposit/game/hot-to-burn' }}><b>Hot to Burn</b></NavLink>.</p>
                        </div>
                    </div>
                </div>
                <button className="register-button">
                    <a href="https://m.supersport.hr/registracija">REGISTRIRAJ SE</a>
                </button>
            </>
        );
    }

    renderStep2() {
        return (
            <div className="top-part" id="top-part-2">
                <div className="top-part-header">
                    <span className="step-number">2</span>
                    {/* <img src="content/images/bonusi/firstdeposit/step_2.png" />*/}
                    <div className="step-image-2"></div>
                </div>
                <div className="top-part-footer">
                    <h1>Uplati</h1>
                    <h2>Osvoji do 300 € BONUSA</h2>
                    <p>Odaberi način uplate koji ti najviše odgovara i uplati prvi iznos na svoj SuperSport račun!</p>
                    <button onClick={() => this.handleClick(2)}>SAZNAJ VIŠE</button>
                </div>
            </div>
        );
    }

    renderStep2How() {
        return (
            <div className="bottom-part step-2" style={{ 'minHeight': '800px' }}>
                <div className="back-button-container">
                    <button className="back-button" onClick={() => this.handleClickBack(2)}>
                        <span className="arrow-back-transparent"></span>
                        Povratak
                    </button>
                </div>
                <div className="how">
                    <span>KAKO DO BONUSA?</span>
                </div>
                <p>Nakon registracije u rubrici bonusi te čeka ponuda bonusa na prvu uplatu. Prije prve uplate prihvati ponudu.</p>
                <p>Prilikom prijenosa sredstava sa Sporta na Casino račun označi "prihvati 100% bonusa na prvu uplatu" i udvostručit ćemo tvoj iznos za igru. Ako primjerice na casino račun preneseš 300 €, dodati ćemo još toliko, te ćeš ukupno imati 600 € za casino igru. <br /> Nakon toga zaigraj Casino igre i osvajaj dobitke da bi ga "oslobodio".</p>
                <img className="gift" src="content/images/bonusi/firstdeposit/gift.png" />
                <p className="thin">Oslobođeni bonus možeš isplatiti. Bonus ćeš osloboditi kad njegov iznos odigraš najmanje 30 puta u igrama koje sudjeluju u oslobađanju bonusa, a popis igara možeš vidjeti <NavLink className="here" to="/popis-igara">ovdje</NavLink>.</p>
                <button><NavLink to="/">ZAIGRAJ</NavLink></button>
                {/*<div style={{ 'clear': 'both' }}></div>*/}
                {/*<div className="rules">Prihvaćanjem bonusa prihvaćaš i <a className="link red" href="https://view.officeapps.live.com/op/embed.aspx?src=https://cdn.supersport.hr/Casino/Documents/Pravila/1stDepositCasinoPravilaPromocije2022.docx" target="_blank"><b>Pravila promocije</b></a> <br />Bonus istovremeno možeš osvojiti u našoj <a className="link red" href="https://m.supersport.hr/sport" target="_blank"><b>Kladionici</b></a></div>*/}
                {/*<div className="rules">Za sve nedoumice slobodno nam se javi <a className="link red" href="https://mcasino.supersport.hr/kontakt"><b>ovdje.</b></a></div>*/}
            </div>
        )
    }

    renderStepPlus() {
        return (
            <div className="top-part" id="top-part-2">
                <div className="top-part-header">
                    <span className="step-plus">+</span>
                    {/*<img className="plus-img" src="content/images/bonusi/firstdeposit/400x2.png" />*/}
                    <div className="step-image-3"></div>
                </div>
                <div className="top-part-footer">
                    <h1>Uplati još</h1>
                    <h2>Osvoji 400 BESPLATNIH VRTNJI</h2>
                    <p>Napravi četiri uplate od minimalno 10€ i pokupi dodatni poklon - 400 besplatnih vrtnji u odabranoj igri.</p>
                    <button onClick={() => this.handleClick(3)}>SAZNAJ VIŠE</button>
                </div>
            </div>
        );
    }

    renderStepPlusHow() {
        return (
            <>
                <div className="bottom-part step-2">
                    <div className="back-button-container">
                        <button className="back-button" onClick={() => this.handleClickBack(3)}>
                            <span className="arrow-back-transparent"></span>
                            Povratak
                        </button>
                    </div>
                    <div className="how">
                        <span>KAKO DO 400 BESPLATNIH VRTNJI?</span>
                    </div>
                    <p>Nakon što odigraš 100 besplatnih vrtnji za registraciju i iskoristiš 100% BONUSA na prvu uplatu, imaš pravo na dodatne pokone.</p>
                    <p>Ukupno možeš osvojiti 400 besplatnih vrtnji u igri John Hunter and the Book of Tut Respin, a do njih ćeš doći naknadnim uplatama.</p>
                    <ul>
                        <li>100 besplatnih vrtnji za drugu uplatu od minimalno 10 €</li>
                        <li>100 besplatnih vrtnji za treću uplatu od minimalno 10 €</li>
                        <li>100 besplatnih vrtnji za četvrtu uplatu od minimalno 10 €</li>
                        <li>100 besplatnih vrtnji za petu uplatu od minimalno 10 €</li>
                    </ul>
                    <p className="thin">Besplatne vrtnje su vrijednosti 0.1 € po vrtnji. Sav dobitak koji osvojiš besplatnim vrtnjama moraš odigrati određeni broj puta u Casino igrama i zatim ga možeš isplatiti na svoj račun. </p>
                    <ul style={{ marginTop: "2rem", fontSize: "14px" }}>
                        <li>Dobitak iz besplatnih vrtnji za drugu uplatu moraš odigrati 4 puta</li>
                        <li>Dobitak iz besplatnih vrtnji za treću uplatu moraš odigrati 3 puta</li>
                        <li>Dobitak iz besplatnih vrtnji za četvrtu uplatu moraš odigrati 2 puta</li>
                        <li>Dobitak iz besplatnih vrtnji za petu uplatu moraš odigrati 1 put</li>
                    </ul>
                </div>
                <div className="games">
                    <h3>IGRE S BESPLATNIM VRTNJAMA</h3>
                    <div className="besplatna-vrtnja-igra">
                        <NavLink to={{ pathname: '/promotions/first-deposit/game/pragmaticplay/john-hunter-and-the-book-of-tut-respin-tm' }}>
                            <img src={"https://cdn.supersport.hr/casino/gameimages/pragmaticplay/john-hunter-and-the-book-of-tut-respin-tm.webp"} />
                        </NavLink>
                        <div className="game-name">
                            John Hunter and the Book of Tut Respin
                            <p>Otkrij egipatske misterije uz hrabrog istraživača Johna Huntera i igru <NavLink className="link red" to={{ pathname: '/promotions/first-deposit/game/pragmaticplay/john-hunter-and-the-book-of-tut-respin-tm' }}><b>John Hunter and the Book of Tut Respin</b></NavLink>.</p>
                        </div>
                    </div>
                </div>
                <button className="play-button">
                    <a href="https://m.supersport.hr/racun#/uplata">UPLATI SREDSTVA</a>
                </button>
            </>
        )
    }

    render() {
        return (
            <>
                <MetaTags title="Bonus dobrodošlice - SuperSport CASINO" description="100% bonus dobrodošlice u SuperSport CASINU!" />
                <Header key="header" {...this.state} {...this.props} />
                <div className='white-background'>
                    {!this.state.button1 && !this.state.button2 && !this.state.button3 &&
                        <div className="banner banner2">
                            <section className="firstdeposit firstdeposit2 banner--inner selected">
                                <div className="banner--content" style={{ height: '146%' }}>
                                    <div className="banner--bg-container first-deposit-2022">
                                        <div className="banner--repeater" />
                                        <div className="banner--background" />
                                        <div className="banner--mask-white" />
                                    </div>
                                    <div className="banner--foreground">
                                        {/*<div className="banner--image">*/}
                                        {/*       <div className="banner--text">*/}
                                        {/*           <div className="text-center">*/}
                                        {/*           </div>*/}
                                        {/*       </div>*/}
                                        {/*   </div>*/}
                                        {/*   <div className="banner--image-2" />*/}
                                        <div className="rive-container">
                                            <RiveComponent
                                                lazyLoad={true}
                                                cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                                src={`${casino.config.casinoCDNImagesUrl}/Banners/FirstDeposit/bonusdobrodoslice_300_web.riv`}
                                                stateMachines="State Machine 1"
                                                width={1200}
                                                height={876}
                                                useOffscreenRenderer={true}
                                                playRequest={true}
                                                disablePlayOutsideViewport={{ target: ".banner--inner", rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    }

                    <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile first-deposit-2022 margin-top-50">
                        {!this.state.button1 && !this.state.button2 && !this.state.button3 &&
                            <div>
                                {this.renderStep1()}
                                {this.renderStep2()}
                                {this.renderStepPlus()}
                            </div>
                        }
                        {this.state.button1 && this.renderStep1How()}
                        {this.state.button2 && this.renderStep2How()}
                        {this.state.button3 && this.renderStepPlusHow()}
                        <div className="bottom-part" >
                            <div className="rules">Prihvaćanjem bonusa prihvaćaš i <a className="link red" href={`${casino.config.casinoCDNDocumentsUrl}/Pravila/1stDepositCasinoPravilaPromocije2023.pdf?c=${casino.config.guiCacheVerzija}`} target="_blank"><b>Pravila promocije</b></a> <br />Bonus istovremeno možeš osvojiti u našoj <a className="link red" href="https://m.supersport.hr/sport" target="_blank"><b>Kladionici</b></a></div>
                            <div className="rules">Za sve nedoumice slobodno nam se javi <a className="link red" href="https://mcasino.supersport.hr/kontakt"><b>ovdje</b></a>.</div>
                        </div>
                    </div>
                </div>

                <GameDetails loadGames={true} {...this.props} {...this.state} routePrefix="/promotions/first-deposit" />
                <ObavijestiCasino {...this.props} />
            </>
        )
    }
};